<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table
        ref="table"
        :max-items="20"
        pagination
        search
        :data="locations"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
               class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
               @click="addLocation"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
            <span class="ml-2 text-base text-primary disabled">Bezorglocatie toevoegen</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">

          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Locatie</vs-th>
        <vs-th sort-key="fees">Bezorgkosten</vs-th>
        <vs-th sort-key="minimum">Minimum</vs-th>
        <vs-th sort-key="actions">Acties</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
        >
          <vs-td>
            <p class="location-name">{{ tr.label }}</p>
          </vs-td>
          <vs-td>
            <p class="location-fee">{{ tr.fee }}</p>

          </vs-td>

          <vs-td>
            <p class="permission-name">{{ tr.minimum }}</p>
          </vs-td>
          <vs-td>
            <p class="deliverer-phone_number">
              <vs-button
                  color="danger"
                  type="flat"
                  ref="loadableButton"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  v-if="staffRoute"
                  @click.stop="startDelete(tr)"
              ></vs-button>
            </p>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <ht-location-popup></ht-location-popup>
    <ht-create-location-popup></ht-create-location-popup>
  </div>
</template>
<script>

import LocationPopup from "./LocationPopup";
import CreateLocationPopup from "./CreateLocationPopup";

export default {
  components: {
    "ht-location-popup": LocationPopup,
    "ht-create-location-popup": CreateLocationPopup,
  },
  data() {
    return {
      locations: [],
      globalLocations: []
    };
  },

  computed: {
    staffRoute() {
      if (this.$route.meta.staff) {
        if (localStorage.getItem('stafftoken') !== null) {
          return true;
        }
      } else {
        if (localStorage.getItem('stafftoken') !== null) {
          return true;
        }
        return false;
      }
    },
  },
  methods: {
    getDeliveryLocations() {
      this.$http.get('v1/delivery-fees?slug=' + this.$route.params.slug, {
        headers: {
          Authorization: "Bearer " + this.$auth.token
        },
      }).then(response => {
        this.locations = response.data.fees;
      }).catch(error => {
        this.$util.logError(error, this.$vs);
      });
    },

    getGlobalDeliveryLocations() {
      this.$http.get('v1/delivery-locations', {
        headers: {
          Authorization: "Bearer " + this.$auth.token
        },
      }).then(response => {
        this.globalLocations = response.data.locations;
      }).catch(error => {
        this.$util.logError(error, this.$vs);
      });
    },

    startDelete(location) {
      let slug = this.$route.params.slug;
      console.log(location);
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Weet je het zeker',
        text: 'Hiermee verwijder je de geselecteerde locatie',
        accept: function () {
          this.loading = true;
          let data = new FormData();
          data.append('_method', 'DELETE');
          data.append('companySlug', slug);
          data.append('deliveryFeeId', location.location_id);
          this.$http
              .post("v1/delivery-location/delete", data, {
                headers: {
                  Authorization: "Bearer " + this.$auth.token
                },
              })
              .then(() => {
                this.loading = false;
                this.$events.fire('refresh-delivery-locations');
                this.$util.notify('Gelukt', 'Locatie is verwijderd!', this.$vs);
              })
              .catch((error) => {
                this.loading = false;
                this.$util.logError(error, this.$vs);
              });
        }
      });
    },

    addLocation() {
      this.$events.fire('open-create-location-popup', this.globalLocations);
      console.log('test');
    },

    deleteLocation(id) {
      let slug = this.$route.params.slug;
      let data = new FormData();
      data.append('_method', 'DELETE');
      data.append('companySlug', slug);
      data.append('deliveryFeeId', this.createLocation.fee);
      this.$http
          .post('/v1/delivery-fee/delete', data, {
            headers: {
              Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
            },
          })
          .then(() => {
            this.showPopup = false;
            this.$vs.notify({
              title: "Gelukt!",
              text: "Locatie is toegevoegd aan restaurant",
              color: "green",
              position: "top-center",
            });
            this.$events.fire('refresh-delivery-locations');
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    }
  },

  mounted() {
    this.getDeliveryLocations();
    this.getGlobalDeliveryLocations();
    this.$events.listen('refresh-delivery-locations', () => {
      this.getDeliveryLocations();
    });
  }
};
</script>